// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"81f4bee5","148":"9f7e5c23","453":"2e88b7ed","746":"238cc10e","764":"1436a1a1","806":"67d98f9a","893":"940c4a4f"}[chunkId] + ".chunk.js";
};